<template>
  <div>
    <component
      :is="section.link ? 'a' : 'div'"
      v-for="section in allowedSections"
      :key="section.image"
      :href="section.link"
      :target="section.link ? '_blank' : null"
      :rel="section.link ? 'noopener noreferrer' : null"
      class="payment row m0"
      :class="{ 'payment--link': section.link }"
    >
      <div class="col-xs-4 row pl0">
        <img :src="section.image" :alt="section.text" />
      </div>
      <p class="col-xs-8 mt0 fs13">
        {{ section.text }}
      </p>
    </component>
  </div>
</template>

<script>
export default {
  name: "ShippingPaymentSection",
  props: {
    productType: {
      type: String,
      required: true,
    },
    isRentalProduct: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sections: [
        {
          image: "/assets/payments-logo/PayPo_logo_kolor.svg",
          text: this.$t("Buy or rent now, pay in 30 days"),
        },
        {
          image: "/assets/shipping-logo/logo_DHL.jpg",
          text: this.$t("Fast and safe shipping in 24 hours!"),
        },
        {
          image: "/assets/shipping-logo/Zabka_logo_2020.svg",
          text: this.$t("Easy return at any Zabka"),
          showOnlyForRental: true,
        },
        {
          image: "/assets/shipping-logo/wygodne-zwroty.svg",
          text: this.$t("Return your order quickly and conveniently within 14 days"),
          link: "https://wygodnezwroty.pl/e-garderobe",
          showOnlyForSale: true,
        },
      ],
    };
  },
  computed: {
    allowedSections() {
      return this.sections.filter((section) =>
        !(section.showOnlyForRental && !this.isRentalProduct) &&
        !(section.showOnlyForSale && this.isRentalProduct)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  max-width: 70px;
  height: auto;
  object-fit: contain;
}
.payment {
  padding: 10px;
  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }
  &--link {
    display: flex;
    color: inherit;
    text-decoration: none;
    &:hover p {
      text-decoration: underline;
    }
  }
  &__label {
    display: block;
    max-width: 70px;
    line-height: 1.2;
  }
}
</style>
